import React from "react";
import { getInitialData } from "../service/apiFetch";
import ContentPage from "../components/utils/ContentPage";

export const getStaticProps = async () => {
  const initialData = await getInitialData("principal-message", {
    contentBlock: "Object",
  });

  return {
    props: {
      websiteData: initialData?.websiteData || "",
      data: initialData?.data || "",
      title: initialData?.title || "",
      metaTags: initialData?.metaTags || "",
      url: initialData?.url || "",
      error: initialData?.error || "",
    },
  };
};

export default function PrincipalMessage({ data }) {
  const block = data?.contentBlock?.PRINCIPAL_MESSAGE;
  return (
    <ContentPage
      heading={block?.heading}
      subHeading={block?.subHeading}
      content={block?.content}
      image={block?.link}
      imageAlt={block?.heading || "Principal message"}
    />
  );
}
